import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostSystemMessageSchema } from './schemas';

export const forumPostSystemMessagesQueryOptions = (id: number) =>
  queryOptions({
    queryKey: QueryKeys.forum.show.systemMessages(id),
    queryFn: async () => {
      const { data: comments } = await fetchJson(`/forum/posts/${id}/system-messages`, {
        schema: apiResourceSchema(forumPostSystemMessageSchema.array()),
      });

      return comments;
    },
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
    // System messages are shown in the comment section.
    // Retry is limited to 1 to avoid slowing down comment loading.
    retry: 1,
  });

export const useForumPostSystemMessages = (id: number) => {
  return useQuery(forumPostSystemMessagesQueryOptions(id));
};
